import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Trait } from 'src/app/_helpers/trait';
import { DataGridRequest } from 'src/app/_models/datagrid';
import { Response201, ResponseAny, ResponseDTO, ResponseDataDTO, ResponseMessage, ResponseSingleMeta } from 'src/app/_models/response-dto';
import { DetailOptions, EmployeeContactDataDTO, EmployeeDTO, EmployeeDataRel, EmployeeDocumentDataDTO } from '../model/employe';
import { OptionValues } from 'src/app/_models/common-dto';
import { EmployeePatchDTO } from '../model/employe';
import { PayloadDTO } from 'src/app/_models/request-dto';
import * as constant from 'src/app/_helpers/constant';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(
    private http: HttpClient
  ) { }

  getEmployees(payload: DataGridRequest): Observable<EmployeeDTO> {
    return this.http.get<ResponseDTO>(constant.API_EMPLOYEE + Trait.RequestParams(payload), {}).pipe(
      map(response => ({
        data: response.data,
        totalRecords: response.meta.page.total
      }) as EmployeeDTO)
    );
  }

  getEmployee(id: string): Observable<EmployeeDataRel> {
    return this.http.get<ResponseDataDTO>(constant.API_EMPLOYEE + "/" + id + "?include=contacts,documents", {}).pipe(
      map(response => ({
        data: response.data,
        included: response.included
      }) as EmployeeDataRel)
    );
  }

  syncEmployees(): Observable<ResponseMessage> {
    return this.http.post<ResponseSingleMeta>(constant.API_EMPLOYEE + "/-actions/sync-bulk", {}).pipe(
      map(response => ({
        message: response.meta.message
      }))
    );
  }

  syncEmployee(data: EmployeePatchDTO): Observable<ResponseMessage> {
    return this.http.patch<ResponseSingleMeta>(constant.API_EMPLOYEE + "/-actions/sync", {data}).pipe(
      map(response => ({
        message: response.meta.message
      }))
    );
  }

  getOptions(): Observable<OptionValues[]> {
    return this.http.get<OptionValues[]>(constant.API_EMPLOYEE + "/-actions/options", {}).pipe(
      map(response => (response))
    );
  }

  getDetailOptions(): Observable<DetailOptions> {
    return this.http.get<DetailOptions>(constant.API_EMPLOYEE + "/-actions/detail-options", {}).pipe(
      map(response => (response))
    );
  }

  getEmployeeId(payload: any): Observable<ResponseAny> {
    return this.http.post<ResponseAny>(constant.API_EMPLOYEE + "/-actions/employee-identity", {payload}).pipe(
      map(response => ({
        data: response.data
      }) as ResponseAny)
    );
  }

  postContact(data: PayloadDTO): Observable<Response201> {
    return this.http.post<ResponseDTO>(constant.API_EMPLOYEE_CONTACT, {data}).pipe(
      map(response => ({
        data: response.data
      }))
    );
  }

  patchContact(id: string, data: PayloadDTO): Observable<EmployeeContactDataDTO> {
    return this.http.patch<ResponseDataDTO>(constant.API_EMPLOYEE_CONTACT + "/" + id, {data}).pipe(
      map(response => ({
        message: response.meta.message,
        data: response.data
      }) as EmployeeContactDataDTO)
    )
  }

  deleteContact(id: string): Observable<ResponseMessage> {
    return this.http.delete<ResponseSingleMeta>(constant.API_EMPLOYEE_CONTACT + "/" + id, {}).pipe(
      map(response => ({
        message: response.meta.message
      }))
    );
  }

  postDocument(data: PayloadDTO): Observable<Response201> {
    return this.http.post<ResponseDTO>(constant.API_EMPLOYEE_DOCUMENT, {data}).pipe(
      map(response => ({
        data: response.data
      }))
    );
  }

  patchDocument(id: string, data: PayloadDTO): Observable<EmployeeDocumentDataDTO> {
    return this.http.patch<ResponseDataDTO>(constant.API_EMPLOYEE_DOCUMENT + "/" + id, {data}).pipe(
      map(response => ({
        message: response.meta.message,
        data: response.data
      }) as EmployeeDocumentDataDTO)
    )
  }

  deleteDocument(id: string): Observable<ResponseMessage> {
    return this.http.delete<ResponseSingleMeta>(constant.API_EMPLOYEE_DOCUMENT + "/" + id, {}).pipe(
      map(response => ({
        message: response.meta.message
      }))
    );
  }
}
